import React from 'react'
import { useAtom } from 'jotai'
import Classnames from 'classnames'

// helper functions
import { returnValue } from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
  isLoggedIn,
  openSignUpModal,
  openShareModal,
} from '@/utils/op-types/store'

// block renderer
import BlockRenderer from '@/components/optypes/frontend/BlockRenderer'

// block builder tools
import StaticContentWrapper from '@/components/optypes/frontend/StaticContentWrapper'
import AddBlockBuilder from '@/components/optypes/frontend/AddBlockBuilder'

// blocks
import StupidBlock from '@/components/optypes/frontend/PHChat/StupidBlock'
import ListOfThings from '@/components/optypes/frontend/PHChat/ListOfThings'

import CustomLinkTest from '@/components/optypes/frontend/PHChat/CustomLinkTest'

// drag and drop context wrapper
import DragWrapper from '@/components/optypes/headlesss-components/DragWrapper'

import dynamic from 'next/dynamic'
const TodosBlock = dynamic(
  () => import('@/components/optypes/frontend/PHChat/TodosBlock'),
  {
    ssr: false,
  }
)

const CardsBlock = dynamic(
  () => import('@/components/optypes/frontend/PHChat/CardsBlock'),
  {
    ssr: false,
  }
)

const TableBlock = dynamic(
  () => import('@/components/optypes/frontend/PHChat/TableBlock'),
  {
    ssr: false,
  }
)

const Components = {
  stupid_block: StupidBlock,
  repeater_test: ListOfThings,
  todos_block: TodosBlock,
  cards_block: CardsBlock,
  table_block: TableBlock,
}

// headless component
import Linker from '@/components/optypes/headlesss-components/Link'

const MainComponentRenderer = () => {
  const [builder] = useAtom(isBuilder)
  const [getLoggedIn, setLoggedIn] = useAtom(isLoggedIn)
  const [isSignUpModalOpen, toggleSignUpModal] = useAtom(openSignUpModal)
  const [isShareModalOpen, toggleShareModal] = useAtom(openShareModal)

  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  return (
    <div
      style={{
        backgroundColor: returnValue('main_background', opDesign, pageDesign),
      }}
      className="p-16"
    >
      {/* example of text */}
      <h2 className="font-bold text-2xl">
        <StaticContentWrapper contentKey="main_headline">
          {returnValue('main_headline', opStatic, pageStatic)}
        </StaticContentWrapper>
      </h2>

      <h2 className="font-bold text-lg mt-2">
        <StaticContentWrapper contentKey="intro_text">
          {returnValue('intro_text', opStatic, pageStatic)}
        </StaticContentWrapper>
      </h2>

      {/* sign up button */}
      {!getLoggedIn && (
        <div
          onClick={() => {
            toggleSignUpModal(true)
          }}
          className="my-8"
        >
          <div className="bg-black cursor-pointer text-white text-xl font-bold rounded inline-block py-2 px-3">
            Sign Up & Save Work
          </div>
        </div>
      )}

      {/* share button */}
      {getLoggedIn && (
        <div
          onClick={() => {
            toggleShareModal(true)
          }}
          className="bg-black cursor-pointer text-white text-xl font-bold rounded inline-block py-2 px-3"
        >
          SHARE!
        </div>
      )}

      <div className="my-3">
        {returnValue('link_obj', opStatic, pageStatic).url && (
          <Linker
            data={returnValue('link_obj', opStatic, pageStatic)}
            className=""
          >
            <CustomLinkTest />
          </Linker>
        )}

        <div className="text-xs">
          {JSON.stringify(returnValue('link_obj', opStatic, pageStatic))}
        </div>
      </div>

      <DragWrapper>
        <div className="grid grid-cols-3 gap-4">
          <div className="">
            {pageBlocks.map(
              (block, index) =>
                block.block == 'stupid_block' && (
                  <BlockRenderer
                    key={index}
                    index={index}
                    Components={Components}
                    block={block}
                  />
                )
            )}

            {/* add block button builder */}
            {builder && (
              <AddBlockBuilder
                autoType="stupid_block"
                btnText="Add Input Block"
              />
            )}
          </div>
          <div className="">
            {pageBlocks.map(
              (block, index) =>
                block.block == 'todos_block' && (
                  <BlockRenderer
                    key={index}
                    index={index}
                    Components={Components}
                    block={block}
                  />
                )
            )}

            {/* add block button builder */}
            {builder && (
              <AddBlockBuilder
                autoType="todos_block"
                btnText="Add Todos Block"
              />
            )}
          </div>

          <div className="">
            {pageBlocks.map(
              (block, index) =>
                block.block == 'cards_block' && (
                  <BlockRenderer
                    key={index}
                    index={index}
                    Components={Components}
                    block={block}
                  />
                )
            )}

            {/* add block button builder */}
            {builder && (
              <AddBlockBuilder autoType="cards_block" btnText="Add  Block" />
            )}
          </div>
        </div>
      </DragWrapper>

      <div className="mt-12">
        <div className="">
          {pageBlocks.map(
            (block, index) =>
              block.block == 'table_block' && (
                <BlockRenderer
                  key={index}
                  index={index}
                  Components={Components}
                  block={block}
                />
              )
          )}

          {/* add block button builder */}
          {builder && (
            <AddBlockBuilder autoType="table_block" btnText="Add Table" />
          )}
        </div>
      </div>

      {/* example of blocks  */}
      {/* {pageBlocks.map((block, index) => (
        <BlockRenderer
          key={index}
          index={index}
          Components={Components}
          block={block}
        />
      ))} */}
    </div>
  )
}

export default MainComponentRenderer
